import React from 'react';
import './PlaceholderPage.css';
import {

  MDBBtn,

} from "mdb-react-ui-kit";

const EbayIntegrationPage = () => {
  const handleEbayIntegrate = async (e) => {
  e.stopPropagation();

  try {
    const res = await fetch(
      "https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net/api/v1/ebayUrlFB",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await res.json();

    if (data?.url) {
      // 🔁 Redirect to eBay OAuth
      window.location.href = data.url;
    } else {
      console.error("eBay auth URL not received");
    }
  } catch (err) {
    console.error("eBay integrate error:", err);
  }
};
  return (
    <div className="placeholder-page">
      <h1 className="page-title">eBay Integration</h1>
      <p className="page-description">
         <MDBBtn
            size="sm"
            color="light"
            className="integrate-btn"
            onClick={handleEbayIntegrate}
          >
              Integrate
        </MDBBtn>
      </p>
    </div>
  );
};

export default EbayIntegrationPage;
